export const validPhoneNumber = new RegExp(
    `^(62)([0-9]{8,15})$`
)